(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    // controller for tasks info
    module.controller('TaskInfoController', ['$uibModalInstance', 'task', TaskInfoControllerFn]);

    function TaskInfoControllerFn($uibModalInstance, task) {
        var vm = this;

        // current task
        vm.task = null;

        activate();

        // cancel
        vm.cancel = function () {
            $uibModalInstance.close();
        };

        // activation work
        function activate() {
            vm.task = task;
        }

    }

})();